// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Daily payout history modal — premium exchange-style (theme-aligned) */

.eph-payout-modal {
  --eph-brand: #1e56f5;
  --eph-brand-soft: rgba(30, 86, 245, 0.12);
  --eph-success: #5eba89;
  --eph-surface: #ffffff;
  --eph-surface-soft: #f8f9fa;
  --eph-border: #f0f0f0;
  --eph-border-strong: #e2e4e8;
  --eph-muted: #6c757d;
  --eph-text: rgba(0, 0, 0, 0.78);
  --eph-heading: rgba(0, 0, 0, 0.88);
  --eph-shadow: 0 8px 32px rgba(30, 86, 245, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  --eph-radius: 16px;
  --eph-radius-sm: 12px;
  --eph-transition: 0.2s ease;
}

.eph-payout-modal__dialog {
  max-width: 720px;
}

.eph-payout-modal__sheet {
  border: none;
  border-radius: var(--eph-radius);
  overflow: hidden;
  background: var(--eph-surface);
  box-shadow: var(--eph-shadow);
}

.eph-payout-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.35rem 1rem;
  background: linear-gradient(180deg, var(--eph-surface-soft) 0%, var(--eph-surface) 100%);
  border-bottom: 1px solid var(--eph-border);
}

.eph-payout-modal__head-main {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  min-width: 0;
}

.eph-payout-modal__icon-wrap {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--eph-brand-soft);
  color: var(--eph-brand);
  font-size: 1.35rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.eph-payout-modal__title {
  margin: 0 0 0.2rem;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--eph-heading);
  line-height: 1.25;
}

.eph-payout-modal__subtitle {
  margin: 0;
  font-size: 0.8rem;
  color: var(--eph-muted);
  line-height: 1.45;
  max-width: 26rem;
}

.eph-payout-modal__head-actions {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  flex-shrink: 0;
}

.eph-payout-modal__badge {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--eph-brand);
  background: var(--eph-surface);
  border: 1px solid rgba(30, 86, 245, 0.22);
  border-radius: 999px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.eph-payout-modal__close {
  opacity: 0.65;
  margin: 0;
  padding: 0.5rem;
  transition: opacity var(--eph-transition);
}

.eph-payout-modal__close:hover {
  opacity: 1;
}

.eph-payout-modal__body {
  padding: 1.1rem 1.35rem 1.35rem;
}

.eph-payout-modal__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  margin-bottom: 0.85rem;
}

.eph-payout-modal__meta-pill {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--eph-muted);
  background: var(--eph-surface-soft);
  border: 1px solid var(--eph-border);
  border-radius: 999px;
  padding: 0.25rem 0.65rem;
}

.eph-payout-modal__meta-pill strong {
  color: var(--eph-text);
  font-weight: 700;
}

.eph-payout-modal__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.85rem;
  padding: 2.5rem 1rem;
  color: var(--eph-muted);
  font-size: 0.875rem;
}

.eph-payout-modal__spinner {
  width: 2.25rem;
  height: 2.25rem;
  border: 3px solid var(--eph-border);
  border-top-color: var(--eph-brand);
  border-radius: 50%;
  animation: eph-spin 0.75s linear infinite;
}

@keyframes eph-spin {
  to {
    transform: rotate(360deg);
  }
}

.eph-payout-modal__alert {
  margin: 0;
  padding: 0.85rem 1rem;
  font-size: 0.875rem;
  border-radius: var(--eph-radius-sm);
  border: 1px solid rgba(232, 162, 60, 0.35);
  background: rgba(232, 162, 60, 0.1);
  color: #8a5a12;
}

.eph-payout-modal__empty {
  text-align: center;
  padding: 2.25rem 1.25rem;
  border: 1px dashed var(--eph-border-strong);
  border-radius: var(--eph-radius-sm);
  background: var(--eph-surface-soft);
}

.eph-payout-modal__empty-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 0.85rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--eph-brand-soft);
  color: var(--eph-brand);
  font-size: 1.5rem;
}

.eph-payout-modal__empty h4 {
  margin: 0 0 0.35rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--eph-heading);
}

.eph-payout-modal__empty p {
  margin: 0;
  font-size: 0.8rem;
  color: var(--eph-muted);
  line-height: 1.5;
}

.eph-payout-modal__table-shell {
  background: var(--eph-surface-soft);
  border: 1px solid var(--eph-border);
  border-radius: var(--eph-radius-sm);
  padding: 0.45rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.eph-payout-modal__table-scroll {
  border-radius: 8px;
  overflow: auto;
  max-height: min(52vh, 420px);
  background: var(--eph-surface);
  border: 1px solid var(--eph-border);
}

.eph-payout-modal__table {
  width: 100%;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.8125rem;
  color: var(--eph-text);
}

.eph-payout-modal__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--eph-surface);
  font-weight: 700;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--eph-muted);
  padding: 0.8rem 0.95rem;
  border-bottom: 1px solid var(--eph-border);
  text-align: left;
  white-space: nowrap;
}

.eph-payout-modal__table thead th:nth-child(2),
.eph-payout-modal__table tbody td:nth-child(2) {
  text-align: right;
}

.eph-payout-modal__table tbody td {
  padding: 0.85rem 0.95rem;
  border-bottom: 1px solid var(--eph-border);
  vertical-align: middle;
  font-weight: 500;
  transition: background var(--eph-transition);
}

.eph-payout-modal__table tbody tr {
  background: var(--eph-surface);
}

.eph-payout-modal__table tbody tr:nth-child(even) {
  background: rgba(248, 249, 250, 0.92);
}

.eph-payout-modal__table tbody tr:hover td {
  background: rgba(30, 86, 245, 0.05);
}

.eph-payout-modal__table tbody tr:last-child td {
  border-bottom: none;
}

.eph-payout-modal__day {
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--eph-heading);
}

.eph-payout-modal__amount {
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--eph-heading);
}

.eph-payout-modal__amount-sym {
  font-weight: 600;
  font-size: 0.78rem;
  color: var(--eph-muted);
  margin-left: 0.2rem;
}

.eph-payout-modal__datetime {
  font-variant-numeric: tabular-nums;
  color: var(--eph-text);
  font-size: 0.8rem;
}

.eph-payout-modal__datetime--muted {
  color: var(--eph-muted);
}

@media (max-width: 575.98px) {
  .eph-payout-modal__head {
    flex-direction: column;
    align-items: stretch;
  }

  .eph-payout-modal__head-actions {
    justify-content: flex-end;
  }

  .eph-payout-modal__title {
    font-size: 1.05rem;
  }

  .eph-payout-modal__table thead th,
  .eph-payout-modal__table tbody td {
    padding: 0.65rem 0.65rem;
    font-size: 0.75rem;
  }
}

/* Dark theme */
body:not(.light_theme) .eph-payout-modal {
  --eph-surface: #1e2229;
  --eph-surface-soft: #171a1f;
  --eph-border: rgba(255, 255, 255, 0.08);
  --eph-border-strong: rgba(255, 255, 255, 0.12);
  --eph-text: rgba(255, 255, 255, 0.85);
  --eph-heading: #ffffff;
  --eph-muted: #9aa3ad;
  --eph-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

body:not(.light_theme) .eph-payout-modal__sheet {
  background: var(--eph-surface);
}

body:not(.light_theme) .eph-payout-modal__head {
  background: linear-gradient(180deg, #22262e 0%, var(--eph-surface) 100%);
  border-bottom-color: var(--eph-border);
}

body:not(.light_theme) .eph-payout-modal__badge {
  background: #252a33;
  border-color: rgba(30, 86, 245, 0.35);
  color: #8eb0ff;
}

body:not(.light_theme) .eph-payout-modal__meta-pill {
  background: #252a33;
  border-color: var(--eph-border);
}

body:not(.light_theme) .eph-payout-modal__alert {
  border-color: rgba(232, 162, 60, 0.4);
  background: rgba(232, 162, 60, 0.12);
  color: #e8c170;
}

body:not(.light_theme) .eph-payout-modal__table-shell {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

body:not(.light_theme) .eph-payout-modal__table thead th {
  background: var(--eph-surface);
}

body:not(.light_theme) .eph-payout-modal__table tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.03);
}

body:not(.light_theme) .eph-payout-modal__table tbody tr:hover td {
  background: rgba(30, 86, 245, 0.14);
}

body:not(.light_theme) .eph-payout-modal__empty {
  background: var(--eph-surface-soft);
  border-color: var(--eph-border-strong);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Earning/earningPayoutModal.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,kCAAkC;EAClC,+EAA+E;EAC/E,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,wFAAwF;EACxF,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,mCAAmC;EACnC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;EAC3C,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uCAAuC;EACvC,8CAA8C;EAC9C,qCAAqC;EACrC,sBAAsB;EACtB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC","sourcesContent":["/* Daily payout history modal — premium exchange-style (theme-aligned) */\n\n.eph-payout-modal {\n  --eph-brand: #1e56f5;\n  --eph-brand-soft: rgba(30, 86, 245, 0.12);\n  --eph-success: #5eba89;\n  --eph-surface: #ffffff;\n  --eph-surface-soft: #f8f9fa;\n  --eph-border: #f0f0f0;\n  --eph-border-strong: #e2e4e8;\n  --eph-muted: #6c757d;\n  --eph-text: rgba(0, 0, 0, 0.78);\n  --eph-heading: rgba(0, 0, 0, 0.88);\n  --eph-shadow: 0 8px 32px rgba(30, 86, 245, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);\n  --eph-radius: 16px;\n  --eph-radius-sm: 12px;\n  --eph-transition: 0.2s ease;\n}\n\n.eph-payout-modal__dialog {\n  max-width: 720px;\n}\n\n.eph-payout-modal__sheet {\n  border: none;\n  border-radius: var(--eph-radius);\n  overflow: hidden;\n  background: var(--eph-surface);\n  box-shadow: var(--eph-shadow);\n}\n\n.eph-payout-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.35rem 1rem;\n  background: linear-gradient(180deg, var(--eph-surface-soft) 0%, var(--eph-surface) 100%);\n  border-bottom: 1px solid var(--eph-border);\n}\n\n.eph-payout-modal__head-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.eph-payout-modal__icon-wrap {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--eph-brand-soft);\n  color: var(--eph-brand);\n  font-size: 1.35rem;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);\n}\n\n.eph-payout-modal__title {\n  margin: 0 0 0.2rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--eph-heading);\n  line-height: 1.25;\n}\n\n.eph-payout-modal__subtitle {\n  margin: 0;\n  font-size: 0.8rem;\n  color: var(--eph-muted);\n  line-height: 1.45;\n  max-width: 26rem;\n}\n\n.eph-payout-modal__head-actions {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.eph-payout-modal__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--eph-brand);\n  background: var(--eph-surface);\n  border: 1px solid rgba(30, 86, 245, 0.22);\n  border-radius: 999px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.eph-payout-modal__close {\n  opacity: 0.65;\n  margin: 0;\n  padding: 0.5rem;\n  transition: opacity var(--eph-transition);\n}\n\n.eph-payout-modal__close:hover {\n  opacity: 1;\n}\n\n.eph-payout-modal__body {\n  padding: 1.1rem 1.35rem 1.35rem;\n}\n\n.eph-payout-modal__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  margin-bottom: 0.85rem;\n}\n\n.eph-payout-modal__meta-pill {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--eph-muted);\n  background: var(--eph-surface-soft);\n  border: 1px solid var(--eph-border);\n  border-radius: 999px;\n  padding: 0.25rem 0.65rem;\n}\n\n.eph-payout-modal__meta-pill strong {\n  color: var(--eph-text);\n  font-weight: 700;\n}\n\n.eph-payout-modal__loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.85rem;\n  padding: 2.5rem 1rem;\n  color: var(--eph-muted);\n  font-size: 0.875rem;\n}\n\n.eph-payout-modal__spinner {\n  width: 2.25rem;\n  height: 2.25rem;\n  border: 3px solid var(--eph-border);\n  border-top-color: var(--eph-brand);\n  border-radius: 50%;\n  animation: eph-spin 0.75s linear infinite;\n}\n\n@keyframes eph-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.eph-payout-modal__alert {\n  margin: 0;\n  padding: 0.85rem 1rem;\n  font-size: 0.875rem;\n  border-radius: var(--eph-radius-sm);\n  border: 1px solid rgba(232, 162, 60, 0.35);\n  background: rgba(232, 162, 60, 0.1);\n  color: #8a5a12;\n}\n\n.eph-payout-modal__empty {\n  text-align: center;\n  padding: 2.25rem 1.25rem;\n  border: 1px dashed var(--eph-border-strong);\n  border-radius: var(--eph-radius-sm);\n  background: var(--eph-surface-soft);\n}\n\n.eph-payout-modal__empty-icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 0.85rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--eph-brand-soft);\n  color: var(--eph-brand);\n  font-size: 1.5rem;\n}\n\n.eph-payout-modal__empty h4 {\n  margin: 0 0 0.35rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--eph-heading);\n}\n\n.eph-payout-modal__empty p {\n  margin: 0;\n  font-size: 0.8rem;\n  color: var(--eph-muted);\n  line-height: 1.5;\n}\n\n.eph-payout-modal__table-shell {\n  background: var(--eph-surface-soft);\n  border: 1px solid var(--eph-border);\n  border-radius: var(--eph-radius-sm);\n  padding: 0.45rem;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);\n}\n\n.eph-payout-modal__table-scroll {\n  border-radius: 8px;\n  overflow: auto;\n  max-height: min(52vh, 420px);\n  background: var(--eph-surface);\n  border: 1px solid var(--eph-border);\n}\n\n.eph-payout-modal__table {\n  width: 100%;\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.8125rem;\n  color: var(--eph-text);\n}\n\n.eph-payout-modal__table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--eph-surface);\n  font-weight: 700;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--eph-muted);\n  padding: 0.8rem 0.95rem;\n  border-bottom: 1px solid var(--eph-border);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.eph-payout-modal__table thead th:nth-child(2),\n.eph-payout-modal__table tbody td:nth-child(2) {\n  text-align: right;\n}\n\n.eph-payout-modal__table tbody td {\n  padding: 0.85rem 0.95rem;\n  border-bottom: 1px solid var(--eph-border);\n  vertical-align: middle;\n  font-weight: 500;\n  transition: background var(--eph-transition);\n}\n\n.eph-payout-modal__table tbody tr {\n  background: var(--eph-surface);\n}\n\n.eph-payout-modal__table tbody tr:nth-child(even) {\n  background: rgba(248, 249, 250, 0.92);\n}\n\n.eph-payout-modal__table tbody tr:hover td {\n  background: rgba(30, 86, 245, 0.05);\n}\n\n.eph-payout-modal__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.eph-payout-modal__day {\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: var(--eph-heading);\n}\n\n.eph-payout-modal__amount {\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: var(--eph-heading);\n}\n\n.eph-payout-modal__amount-sym {\n  font-weight: 600;\n  font-size: 0.78rem;\n  color: var(--eph-muted);\n  margin-left: 0.2rem;\n}\n\n.eph-payout-modal__datetime {\n  font-variant-numeric: tabular-nums;\n  color: var(--eph-text);\n  font-size: 0.8rem;\n}\n\n.eph-payout-modal__datetime--muted {\n  color: var(--eph-muted);\n}\n\n@media (max-width: 575.98px) {\n  .eph-payout-modal__head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .eph-payout-modal__head-actions {\n    justify-content: flex-end;\n  }\n\n  .eph-payout-modal__title {\n    font-size: 1.05rem;\n  }\n\n  .eph-payout-modal__table thead th,\n  .eph-payout-modal__table tbody td {\n    padding: 0.65rem 0.65rem;\n    font-size: 0.75rem;\n  }\n}\n\n/* Dark theme */\nbody:not(.light_theme) .eph-payout-modal {\n  --eph-surface: #1e2229;\n  --eph-surface-soft: #171a1f;\n  --eph-border: rgba(255, 255, 255, 0.08);\n  --eph-border-strong: rgba(255, 255, 255, 0.12);\n  --eph-text: rgba(255, 255, 255, 0.85);\n  --eph-heading: #ffffff;\n  --eph-muted: #9aa3ad;\n  --eph-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);\n}\n\nbody:not(.light_theme) .eph-payout-modal__sheet {\n  background: var(--eph-surface);\n}\n\nbody:not(.light_theme) .eph-payout-modal__head {\n  background: linear-gradient(180deg, #22262e 0%, var(--eph-surface) 100%);\n  border-bottom-color: var(--eph-border);\n}\n\nbody:not(.light_theme) .eph-payout-modal__badge {\n  background: #252a33;\n  border-color: rgba(30, 86, 245, 0.35);\n  color: #8eb0ff;\n}\n\nbody:not(.light_theme) .eph-payout-modal__meta-pill {\n  background: #252a33;\n  border-color: var(--eph-border);\n}\n\nbody:not(.light_theme) .eph-payout-modal__alert {\n  border-color: rgba(232, 162, 60, 0.4);\n  background: rgba(232, 162, 60, 0.12);\n  color: #e8c170;\n}\n\nbody:not(.light_theme) .eph-payout-modal__table-shell {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\nbody:not(.light_theme) .eph-payout-modal__table thead th {\n  background: var(--eph-surface);\n}\n\nbody:not(.light_theme) .eph-payout-modal__table tbody tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.03);\n}\n\nbody:not(.light_theme) .eph-payout-modal__table tbody tr:hover td {\n  background: rgba(30, 86, 245, 0.14);\n}\n\nbody:not(.light_theme) .eph-payout-modal__empty {\n  background: var(--eph-surface-soft);\n  border-color: var(--eph-border-strong);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
